const Unauthorized = () => {
  return (
    <div className="flex justify-center">
      <h3 className="font-bold">Unauthorized</h3>
    </div>
  );
};
export default Unauthorized;
